import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getReferralPayouts } from '~/actions';
import { useIsReferralRebuildEnabled } from '~/hooks/useIsReferralRebuildEnabled';
import { useUserSelector } from '~/hooks/useUserSelector';

const requestInterval = 1 * 60 * 60 * 1000; // 1 hour in milliseconds

export const useReferralPayout = () => {
  const dispatch = useDispatch();
  const user = useUserSelector();
  const userId = user?.id;
  // GOTU-7435: the payout popup (e-gift) is a v1 surface. Once the rebuild is
  // live it must not show, so the fetch that feeds `ReferralRewardPopup` is
  // skipped — mirroring mobile's `checkReferralPayouts` early return.
  const isReferralRebuildEnabled = useIsReferralRebuildEnabled();

  const shouldRequestPayout = useCallback(() => {
    if (!userId || isReferralRebuildEnabled) return false;

    try {
      const prevRequestTime = localStorage.getItem(`prevReferralPayoutReqDate-${userId}`);
      return !prevRequestTime || Date.now() - new Date(prevRequestTime).getTime() > requestInterval;
    } catch {
      return false;
    }
  }, [userId, isReferralRebuildEnabled]);

  useEffect(() => {
    if (shouldRequestPayout()) {
      dispatch(getReferralPayouts());
      localStorage.setItem(`prevReferralPayoutReqDate-${userId}`, new Date().toISOString());
    }
  }, [dispatch, shouldRequestPayout, userId]);
};
